import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import SettingService from "../../../services/OrderingServices/SettingService";
import toast from "react-hot-toast";

import {
  Card,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";

const GeneratePrintToken = () => {
  const [responseData, setResponseData] = useState();
  const [modalOpen, setModalOpen] = useState(false);

  const handleGenerateToken = async () => {
    try {
      const response = await SettingService.createPrintToken();
      setResponseData(response); // Assuming the response contains a token
      toast.success("Print token generated successfully.");
      setModalOpen(true); // Open modal after generating token
    } catch (error) {
      console.log(error);
      toast.error("Failed to generate print token.");
    }
  };

  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb pageTitle="Generate Print Token" />
      </div>
      <div className="d-flex justify-content-center align-content-center align-items-center mt-0 mt-lg-5 ">
        <Card className="col-12 col-lg-6 col-md-6">
          <CardBody>
            <h4 className="mb-3 text-center">Generate Print Token</h4>
            <p>
              A <strong>print token</strong> is used to authenticate your
              printer with the system. Once generated, you need to copy and
              paste this token into the printer configuration page of your
              organization settings.
            </p>
            <ul className="mb-4">
              <li>
                Click the <strong>Generate</strong> button below to create a new
                token.
              </li>
              <li>Copy the generated token from the popup.</li>
              <li>
               Set this token to your windows print service
              </li>
            </ul>
            <div className="text-center">
              <button
                className="btn btn-success"
                onClick={() => handleGenerateToken()}
              >
                Generate
              </button>
            </div>
          </CardBody>
        </Card>
      </div>

      {/* Modal for displaying the token */}
      <Modal
        isOpen={modalOpen}
        toggle={() => setModalOpen(false)}
        static
        backdrop={true}
      >
        <ModalHeader toggle={() => setModalOpen(false)}>
          Printer Print Token
        </ModalHeader>
        <ModalBody>
          <div>
            <div className="d-flex justify-content-end mb-2">
              <button
                className="btn btn-light align-items-center mb-2 justify-content-end"
                onClick={() => {
                  if (responseData?.printToken) {
                    navigator.clipboard.writeText(responseData.printToken);
                    toast.success("Token copied to clipboard!");
                  } else {
                    toast.error("No token to copy.");
                  }
                }}
              >
                <i className="ri-file-copy-line me-1"></i>
                Copy
              </button>
            </div>

            <Card className="shadow-sm">
              <CardBody>
                <code className="d-block">{responseData?.printToken}</code>
              </CardBody>
            </Card>

            <p className="text-warning mt-2">
              Please <strong>copy the token</strong> for future reference.
            </p>
          </div>
        </ModalBody>
        <ModalFooter>
          <button
            className="btn btn-primary"
            onClick={() => setModalOpen(false)}
          >
            Close
          </button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default GeneratePrintToken;
